import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-warning.svg'
import _imports_1 from '@/assets/area/visitors/icon-persona-triangle.svg'


const _withScopeId = n => (_pushScopeId("data-v-0f17c9fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-flex jr-relative jr-w-full" }
const _hoisted_2 = { class: "jr-py-1" }
const _hoisted_3 = { class: "jr-block" }
const _hoisted_4 = { class: "jr-truncate jr-align-middle jr-max-w-xs jr-inline-block jr-text-primary jr-font-medium jr-mr-5" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jr-inline-block jr-text-s" }, "エリア来訪者の属性", -1))
const _hoisted_8 = { class: "jr-relative" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-center jr-text-primary jr-py-11 jr-text-lg" }, "エリア来訪者の属性（性別・年代・ペルソナ）", -1))
const _hoisted_10 = { class: "jr-mt-15" }
const _hoisted_11 = { class: "jr-flex jr-items-center" }
const _hoisted_12 = { class: "jr-relative jr-bg-white jr-m-auto jr-text-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jr-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "jr-m-auto",
    src: _imports_0,
    alt: "icon-warning"
  })
], -1))
const _hoisted_14 = { class: "jr-text-xl jr-text-primary jr-mt-6.5 jr-font-bold" }
const _hoisted_15 = {
  key: 0,
  class: "jr-flex"
}
const _hoisted_16 = { class: "jr-flex-1 jr-mr-10" }
const _hoisted_17 = { class: "jr-w-9/25" }
const _hoisted_18 = {
  key: 1,
  class: "jr-relative jr-bg-gray-soft jr-flex jr-flex-wrap jr-justify-center jr-rounded-md jr-px-3.5 jr-pt-7.5 jr-pb-2 jr-mb-10 jr-mt-15"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon-persona-triangle",
  class: "jr-absolute jr--top-11 transition triangle"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AreaFilterBadge = _resolveComponent("AreaFilterBadge")!
  const _component_VisitorBarChart = _resolveComponent("VisitorBarChart")!
  const _component_VisitorDoughnutChart = _resolveComponent("VisitorDoughnutChart")!
  const _component_UIPersona = _resolveComponent("UIPersona")!
  const _component_AreaSearchFilter = _resolveComponent("AreaSearchFilter")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "content-download-area-visitor",
      class: "transition-left transition-right jr-relative jr-bg-white jr-flex-1 jr-w-full jr-h-full jr-bottom-0 jr-left-0 jr-px-9.5 jr-overflow-y-scroll",
      style: _normalizeStyle({ marginLeft: _ctx.sbMinimum ? '64px' : '240px', marginRight: _ctx.filterMinimum ? '60px' : '292px' })
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, [
            (_ctx.prefLabels.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.prefLabels), 1))
              : _createCommentVNode("", true),
            (_ctx.prefLabels.length === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "エリア選択"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass([{ 'badge-contents': !_ctx.isCapturing }, "jr-flex jr-flex-wrap jr-mt-1.5 jr-overflow-x-auto"])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badges, (badge, index) => {
              return (_openBlock(), _createBlock(_component_AreaFilterBadge, {
                class: "badge-box jr-mb-2",
                key: index,
                title: badge.title,
                content: badge.content
              }, null, 8, ["title", "content"]))
            }), 128))
          ], 2)
        ])
      ], 512), [
        [_vShow, _ctx.isCapturing]
      ]),
      _hoisted_9,
      _withDirectives(_createElementVNode("figure", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.isErrorChart || _ctx.isErrorDoughnut]
      ]),
      (!_ctx.isErrorDoughnut && !_ctx.isErrorChart)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createVNode(_component_VisitorBarChart, {
                labels: _ctx.labels,
                men: _ctx.men,
                women: _ctx.women,
                label: "性別・年代別比"
              }, null, 8, ["labels", "men", "women"]), [
                [_vShow, _ctx.persona.length > 0]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createVNode(_component_VisitorDoughnutChart, {
                width: 290,
                height: 290,
                label: "ペルソナ"
              }, null, 512), [
                [_vShow, _ctx.hasAges]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isErrorDoughnut && !_ctx.isErrorChart)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personas, (persona, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "jr-w-1/3 jr-mb-5.5 jr-px-3.5",
                key: persona.id
              }, [
                _createVNode(_component_UIPersona, {
                  id: index + 1,
                  age: persona.age,
                  gender: persona.gender,
                  slogan: persona.slogan,
                  color: _ctx.personaColors[index],
                  avatar: persona.avatar
                }, null, 8, ["id", "age", "gender", "slogan", "color", "avatar"])
              ]))
            }), 128))
          ], 512)), [
            [_vShow, _ctx.personas.length > 0]
          ])
        : _createCommentVNode("", true)
    ], 4),
    _createVNode(_component_AreaSearchFilter, {
      onSearch: _ctx.handleSearch,
      onResize: _ctx.handleFilterResize
    }, null, 8, ["onSearch", "onResize"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}